import { formatearMoneda, type ServicioVista } from '@barbones/shared';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Campo, Select } from '@/components/ui/form';

interface Props {
  servicios: ServicioVista[];
  /** Ids elegidos en orden; `''` es un combo aún en «Seleccionar servicio». */
  valor: string[];
  onCambiar: (ids: string[]) => void;
  /** Error a mostrar bajo el primer combo vacío. */
  error?: string;
  /** Servicios de la cita que ya no están en el catálogo activo (al editar). */
  extra?: { id: string; nombre: string; precio: number }[];
  etiqueta?: string;
}

/** Servicios de una cita: el primero obligatorio y los demás con «+ Agregar otro servicio». */
export function ServiciosCita({ servicios, valor, onCambiar, error, extra = [], etiqueta = 'Servicio' }: Props) {
  const opciones = [...extra.filter((e) => !servicios.some((s) => s.id === e.id)), ...servicios];
  const primerVacio = valor.indexOf('');
  const total = valor.reduce((suma, id) => suma + (opciones.find((s) => s.id === id)?.precio ?? 0), 0);
  const cambiar = (i: number, id: string) => onCambiar(valor.map((v, j) => (j === i ? id : v)));

  return (
    <div className="flex flex-col gap-2">
      {valor.map((actual, i) => (
        <div key={i} className="flex items-end gap-2">
          <Campo etiqueta={i === 0 ? etiqueta : `Servicio ${i + 1}`} requerido={i === 0} error={i === primerVacio ? error : undefined} className="flex-1">
            {(p) => (
              <Select {...p} value={actual} onChange={(e) => cambiar(i, e.target.value)}>
                <option value="">Seleccionar servicio</option>
                {opciones.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.nombre}
                  </option>
                ))}
              </Select>
            )}
          </Campo>
          {i > 0 && (
            <Button
              variante="fantasma"
              tamano="icono"
              aria-label={`Quitar servicio ${i + 1}`}
              onClick={() => onCambiar(valor.filter((_, j) => j !== i))}
              className={i === primerVacio && error ? 'mb-6' : undefined}
            >
              <X />
            </Button>
          )}
        </div>
      ))}
      <div className="flex items-center justify-between gap-2">
        <Button variante="fantasma" onClick={() => onCambiar([...valor, ''])} className="self-start">
          + Agregar otro servicio
        </Button>
        {total > 0 && <span className="cifras text-[13px] font-medium">Total: {formatearMoneda(total)}</span>}
      </div>
    </div>
  );
}
